// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lQqX","label":"styles_label__ytvyJ"};